// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios'; /* 引入axios进行地址访问*/
import 'vue-googlemaps/dist/vue-googlemaps.css'
import VueGoogleMaps from 'vue-googlemaps'
import animated from 'animate.css'
import router from './router'
import rem from './assets/js/rem.js'
import echarts from 'echarts'
Vue.prototype.$echarts = echarts
// await:
Vue.use(animated)
ElementUI.Dialog.props.lockScroll.default = false;
Vue.use(ElementUI);
Vue.prototype.$http = axios;
Vue.config.productionTip = false

Vue.use(VueGoogleMaps, {
  load: {
    //填入申请的apiKey账号
    apiKey: 'AIzaSyC5lfNQ6xGEbheJz6O9Z7qABKIWCB524z0',
    libraries: ['places'],
    useBetaRenderer: false,
  },
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js